import React, { useState, useEffect } from 'react';
import SelectablePromptCard from './SelectablePromptCard';
import * as promptLibraryService from '../../../promptLibrary/data/services/promptLibraryService';
import './PromptSelectionScreen.css';

const PromptSelectionScreen = ({ 
  activity, 
  activityIndex, 
  totalActivities, 
  selectedPromptIds, 
  onPromptToggle,
  onNext,
  onBack,
  organizationId,
  userId
}) => {
  const [prompts, setPrompts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadPrompts = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Fetch prompts filtered by activity type
        const filters = {
          organizationId: organizationId || null,
          userId: userId || null,
          promptType: 'global', // Only fetch global prompts for weekly planner
          activityTypeId: activity?.activityTypeId || null, // Filter by activity type
        };
        
        const allPrompts = await promptLibraryService.getAllPrompts(filters);
        
        // Prompts are already filtered by activity type via the API
        setPrompts(allPrompts);
      } catch (err) {
        console.error('Error loading prompts:', err);
        setError('Failed to load prompts');
      } finally {
        setLoading(false);
      }
    };

    loadPrompts();
  }, [activity?.activityTypeId, organizationId, userId]);

  const handlePromptToggle = (promptId) => {
    if (onPromptToggle) {
      onPromptToggle(promptId);
    }
  };

  const handleNext = () => {
    if (onNext) {
      onNext();
    }
  };

  const handleBack = () => {
    if (onBack) {
      onBack();
    }
  };

  const isLastActivity = activityIndex === totalActivities - 1;

  return (
    <div className="prompt-selection-screen">
      <div className="prompt-selection-header">
        <h2 className="prompt-selection-title">Select prompts you want to try</h2>
        <p className="prompt-selection-subtext">{activity.activityTitle}</p>
      </div>

      <div className="prompt-selection-content">
        {loading ? (
          <div className="prompt-loading">Loading prompts...</div>
        ) : error ? (
          <div className="prompt-error">{error}</div>
        ) : prompts.length === 0 ? (
          <div className="prompt-empty">No prompts available for this activity.</div>
        ) : (
          <div className="prompt-cards-grid">
            {prompts.map((prompt) => {
              const isSelected = selectedPromptIds.includes(prompt.id);
              return (
                <SelectablePromptCard
                  key={`${prompt.id}-${isSelected}`}
                  prompt={prompt}
                  isSelected={isSelected}
                  onToggle={handlePromptToggle}
                />
              );
            })}
          </div>
        )}
      </div>

      <div className="prompt-selection-footer">
        <div className="prompt-selection-progress">
          {activityIndex + 1} of {totalActivities}
        </div>
        <div className="prompt-selection-actions">
          {activityIndex > 0 && (
            <button className="prompt-back-button" onClick={handleBack}>
              Back
            </button>
          )}
          <button 
            className="prompt-next-button" 
            onClick={handleNext}
          >
            {isLastActivity ? 'Save' : 'Next'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromptSelectionScreen;

